import { render, staticRenderFns } from "./CreditBookMovimientos.vue?vue&type=template&id=3352f59d"
import script from "./CreditBookMovimientos.vue?vue&type=script&lang=js"
export * from "./CreditBookMovimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports